import { appBus } from '@/events/bus'

let csrfToken: string | undefined
export function setCsrfToken(token: string | undefined) { csrfToken = token || undefined }
export function getCsrfToken() { return csrfToken }

function csrfCookieToken() {
  if (typeof document === 'undefined') return undefined
  const prefix = 'ashare_v2_csrf='
  const cookie = document.cookie
    .split(';')
    .map(value => value.trim())
    .find(value => value.startsWith(prefix))
  if (!cookie) return undefined
  try {
    return decodeURIComponent(cookie.slice(prefix.length)) || undefined
  } catch {
    return undefined
  }
}

export async function fetchJson<T>(path: string, init?: RequestInit): Promise<T> {
  const method = (init?.method ?? 'GET').toUpperCase()
  const headers: Record<string, string> = { Accept: 'application/json' }
  if (init?.headers instanceof Headers) init.headers.forEach((value, key) => { headers[key] = value })
  else if (Array.isArray(init?.headers)) init.headers.forEach(([key, value]) => { headers[key] = value })
  else Object.assign(headers, init?.headers)
  const activeCsrfToken = csrfCookieToken() ?? csrfToken
  if (activeCsrfToken && method !== 'GET' && method !== 'HEAD') headers['X-CSRF-Token'] = activeCsrfToken
  const response = await fetch(path, { ...init, headers })
  if (!response.ok) {
    if (response.status === 401) appBus.emit('session:expired', undefined)
    let detail = `请求失败（${response.status}）`
    try { const body = await response.json() as { detail?: string; title?: string }; detail = body.detail ?? body.title ?? detail } catch { /* a non-json response is still a useful error */ }
    throw new Error(detail)
  }
  if (response.status === 204) return undefined as T
  return response.json() as Promise<T>
}

export function semanticIdempotencyKey(scope: string, payload: unknown): string {
  void payload
  return `ui:${scope.replace(/[^a-zA-Z0-9:._-]/g, '-').slice(0, 80)}:${crypto.randomUUID()}`
}

export async function postJson<T, B>(path: string, body: B, idempotencyKey?: string): Promise<T> {
  return fetchJson<T>(path, { method: 'POST', headers: { 'Content-Type': 'application/json', ...(idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {}) }, body: JSON.stringify(body) })
}

export async function putJson<T, B>(path: string, body: B): Promise<T> {
  return fetchJson<T>(path, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
}

export async function postForm<T>(path: string, form: FormData): Promise<T> {
  return fetchJson<T>(path, { method: 'POST', body: form })
}
